const question3 = {
    'question': 'Jak długo trwa terapia EMDR?',
    'answer': 'Czas trwania terapii EMDR zależy od indywidualnych potrzeb pacjenta. Zazwyczaj terapia trwa od 6 do 12 sesji, ale może trwać dłużej w przypadku bardziej złożonych problemów.',
}

export default question3;